/**
 * Appstle Build-a-Box bridge for the custom BYOB funnel.
 *
 * Subscriptions are NOT created via the Admin API from the browser. Appstle creates
 * the contract when the customer completes checkout with cart lines that include:
 *   - selling_plan (Shopify selling plan ID from Appstle)
 *   - BAB line item properties (shared _bundleUid per box session)
 *
 * Config is read from shop metafields (appstle_subscription.*) via #appstle-byob-config.
 */
(function () {
  var STORAGE_KEY = 'conger_byob';
  var BUNDLE_UID_KEY = 'conger_byob_bundle_uid';

  function isOneTimeFrequency(value) {
    return String(value || '').trim() === 'one_time';
  }

  function readConfig() {
    var node = document.getElementById('appstle-byob-config');
    var config = null;

    if (node) {
      try {
        config = JSON.parse(node.textContent);
      } catch (error) {
        config = null;
      }
    }

    config = config || {};

    var handleNode = document.querySelector('[data-byob-appstle-handle]');
    if (handleNode) {
      var handle = handleNode.getAttribute('data-byob-appstle-handle');
      if (handle) config.bundleHandle = handle;
    }

    var state = readState();
    if (state.appstle_bundle_handle) {
      config.bundleHandle = normalizeBundleHandle(state.appstle_bundle_handle);
    }

    if (config.bundleHandle) {
      config.bundleHandle = normalizeBundleHandle(config.bundleHandle);
    }

    var byWeek = sellingPlansByWeekFromPage();
    if (byWeek && Object.keys(byWeek).length) {
      config.sellingPlansByWeek = Object.assign({}, config.sellingPlansByWeek, byWeek);
    }

    var planOverride = sellingPlanIdFromPage();
    if (planOverride) {
      config.sellingPlanIdOverride = planOverride;
    }

    return config;
  }

  function normalizeBundleHandle(handle) {
    if (!handle) return '';
    var value = handle.toString().trim();
    if (!value) return '';

    var match = value.match(/\/bb\/([^/?#]+)/i);
    if (match && match[1]) return match[1];

    if (/^https?:\/\//i.test(value)) {
      try {
        var parts = new URL(value).pathname.split('/').filter(Boolean);
        return parts.length ? parts[parts.length - 1] : value;
      } catch (error) {
        return value;
      }
    }

    return value;
  }

  function sellingPlansByWeekFromPage() {
    var nodes = document.querySelectorAll('[data-byob-selling-plans-by-week]');
    var merged = {};
    var i;

    for (i = 0; i < nodes.length; i++) {
      var raw = nodes[i].getAttribute('data-byob-selling-plans-by-week');
      if (!raw) continue;

      try {
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          merged = Object.assign(merged, parsed);
        }
      } catch (error) {
        /* ignore */
      }
    }

    return merged;
  }

  function sellingPlanIdFromPage() {
    var nodes = document.querySelectorAll('[data-byob-selling-plan-id]');
    for (var i = 0; i < nodes.length; i++) {
      var value = (nodes[i].getAttribute('data-byob-selling-plan-id') || '').trim();
      if (value) return value;
    }
    return '';
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeState(nextState) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
    } catch (error) {
      /* ignore */
    }
  }

  function ensureBundleUid() {
    try {
      var existing = sessionStorage.getItem(BUNDLE_UID_KEY);
      if (existing) return existing;

      var uid = self.crypto && self.crypto.randomUUID
        ? self.crypto.randomUUID()
        : 'byob-' + Date.now();

      sessionStorage.setItem(BUNDLE_UID_KEY, uid);
      return uid;
    } catch (error) {
      return 'byob-' + Date.now();
    }
  }

  function flattenPlans(raw) {
    if (!raw) return [];

    if (Array.isArray(raw)) return raw;

    if (Array.isArray(raw.sellingPlans)) return raw.sellingPlans;
    if (Array.isArray(raw.plans)) return raw.plans;

    if (Array.isArray(raw.groups)) {
      return raw.groups.reduce(function (acc, group) {
        if (Array.isArray(group.sellingPlans)) {
          return acc.concat(group.sellingPlans);
        }
        if (Array.isArray(group.plans)) {
          return acc.concat(group.plans);
        }
        return acc;
      }, []);
    }

    if (typeof raw === 'object') {
      if (raw.selling_plans) return flattenPlans(raw.selling_plans);
      if (raw.subscriptionPlans) return flattenPlans(raw.subscriptionPlans);

      var values = Object.keys(raw).map(function (key) {
        return raw[key];
      }).filter(function (entry) {
        return entry && typeof entry === 'object';
      });

      if (values.length) {
        return values.reduce(function (acc, entry) {
          return acc.concat(flattenPlans(entry));
        }, []);
      }
    }

    return [];
  }

  function plansFromBundles(config) {
    var bundles = (config && config.bundles) || [];

    return bundles.reduce(function (acc, bundle) {
      if (!bundle) return acc;
      return acc.concat(flattenPlans(
        bundle.sellingPlans ||
        bundle.subscriptionPlans ||
        bundle.selling_plans ||
        bundle.plans ||
        []
      ));
    }, []);
  }

  function plansFromAppstleBundleEntries(config) {
    var bundles = (config && config.bundles) || [];
    var plans = [];

    bundles.forEach(function (entry) {
      if (!entry) return;

      plans = plans.concat(flattenPlans(entry.subscriptionGroupPlans));
      plans = plans.concat(flattenPlans(entry.subscriptionPlans));
    });

    return plans;
  }

  function allPlans(config) {
    var plans = flattenPlans(config && config.sellingPlansRaw);
    if (plans.length) return plans;

    plans = plansFromAppstleBundleEntries(config);
    if (plans.length) return plans;

    plans = plansFromBundles(config);
    if (plans.length) return plans;

    return flattenPlans(config && config.babSettings);
  }

  function planId(plan) {
    if (!plan) return '';
    var id = plan.id || plan.sellingPlanId || plan.shopifySellingPlanId || plan.gid;
    if (!id) return '';
    return id.toString().replace('gid://shopify/SellingPlan/', '');
  }

  function planLabel(plan) {
    return (plan.name || plan.sellingPlanName || plan.title || plan.label || '').toString();
  }

  function planWeeks(plan) {
    var name = planLabel(plan).toLowerCase();
    var match = name.match(/(\d+)\s*week/);
    if (match) return parseInt(match[1], 10);

    var policy = plan.billingPolicy || plan.deliveryPolicy || plan.policy || {};
    var interval = (policy.interval || plan.frequencyInterval || '').toString().toUpperCase();
    var count = parseInt(policy.intervalCount || plan.frequencyCount || plan.intervalCount || 0, 10);

    if (interval === 'WEEK' && count > 0) return count;
    if (interval === 'DAY' && count > 0 && count % 7 === 0) return count / 7;

    return 0;
  }

  function resolveSellingPlanId(weeks, config) {
    config = config || readConfig();
    var targetWeeks = parseInt(weeks, 10);
    if (!Number.isFinite(targetWeeks) || targetWeeks <= 0) return '';

    var weekKey = String(targetWeeks);
    var byWeek = Object.assign({}, config.sellingPlansByWeek || {}, sellingPlansByWeekFromPage());
    if (byWeek[weekKey]) {
      return planId({ id: byWeek[weekKey] });
    }

    if (config.sellingPlanIdOverride && targetWeeks === 4) {
      return planId({ id: config.sellingPlanIdOverride });
    }

    return '';
  }

  function sellingPlanIdForVariant(variantId) {
    if (!variantId) return '';

    var card = document.querySelector('[data-byob-shop-card][data-byob-shop-variant-id="' + variantId + '"]');
    if (!card) return '';

    return (card.getAttribute('data-byob-shop-selling-plan-id') || '').trim();
  }

  function pickBundle(config) {
    var bundles = (config && config.bundles) || [];
    var handle = (config && config.bundleHandle) || '';

    if (handle) {
      var normalized = normalizeBundleHandle(handle);
      var matched = bundles.find(function (bundle) {
        if (!bundle) return false;
        var bundleHandleValue = normalizeBundleHandle(bundle.bundleHandle || bundle.handle || '');
        return bundleHandleValue === normalized;
      });
      if (matched) return matched;
    }

    return bundles.find(Boolean) || null;
  }

  function bundleHandle(config) {
    var bundle = pickBundle(config);
    if (!bundle) return (config && config.bundleHandle) || '';
    return (bundle.bundleHandle || bundle.handle || config.bundleHandle || '').toString();
  }

  function syncSellingPlanFromFrequency(weeks) {
    var config = readConfig();
    var state = readState();
    var sellingPlanId = isOneTimeFrequency(weeks) ? '' : resolveSellingPlanId(weeks, config);

    state.delivery_frequency = weeks;
    if (sellingPlanId) {
      state.selling_plan_id = sellingPlanId;
    } else {
      delete state.selling_plan_id;
    }

    writeState(state);
    return sellingPlanId;
  }

  function buildLineItemProperties(extra) {
    var config = readConfig();
    var state = readState();
    var bundle = pickBundle(config);
    var uid = ensureBundleUid();
    var handle = bundleHandle(config);

    var properties = {
      _bundleUid: uid,
      _byob_flow: 'true'
    };

    if (handle) {
      properties._bundleHandle = handle;
    }

    if (bundle) {
      if (bundle.bundleName || bundle.name) {
        properties._bundleName = (bundle.bundleName || bundle.name).toString();
      }
      if (bundle.id) {
        properties._bundleId = bundle.id.toString();
      }
      if (bundle.bundleProductId || bundle.productId) {
        properties._bundleProductId = (bundle.bundleProductId || bundle.productId).toString();
      }
    }

    if (state.household) properties._byob_household = state.household;
    if (state.cook_frequency) properties._byob_cook_frequency = state.cook_frequency;
    if (state.cook_style) properties._byob_cook_style = state.cook_style;
    if (state.meat_preference) properties._byob_meat = state.meat_preference;
    if (state.delivery_frequency) properties._byob_frequency = state.delivery_frequency;
    if (state.delivery_frequency && !isOneTimeFrequency(state.delivery_frequency)) {
      properties._byob_selling_plan_id = (state.selling_plan_id || '').toString();
    }

    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        if (extra[key] != null && extra[key] !== '') {
          properties[key] = extra[key];
        }
      });
    }

    return properties;
  }

  function requestVolumeDiscount() {
    document.dispatchEvent(new CustomEvent('appstleBundlesAppliedVolumeDiscount:request', { detail: true }));
    window.dispatchEvent(new CustomEvent('appstleBundlesAppliedVolumeDiscount:request', { detail: true }));
  }

  function ensureSellingPlanId(state, config) {
    config = config || readConfig();
    state = state || readState();

    if (isOneTimeFrequency(state.delivery_frequency)) {
      delete state.selling_plan_id;
      writeState(state);
      return '';
    }

    var weeks = state.delivery_frequency || '4';
    var resolved = resolveSellingPlanId(weeks, config);
    if (resolved) {
      state.selling_plan_id = resolved;
      writeState(state);
      return resolved;
    }

    if (typeof URLSearchParams !== 'undefined') {
      var fromUrl = new URLSearchParams(window.location.search).get('byob_selling_plan');
      if (fromUrl) {
        state.selling_plan_id = fromUrl;
        writeState(state);
        return fromUrl;
      }
    }

    if (state.selling_plan_id) {
      return state.selling_plan_id.toString();
    }

    return '';
  }

  function resolveSellingPlanForVariant(variantId, state, config, options) {
    options = options || {};
    config = config || readConfig();
    state = state || readState();

    if (isOneTimeFrequency(state.delivery_frequency)) return '';

    var fromQuiz = ensureSellingPlanId(state, config);
    if (fromQuiz) return fromQuiz;

    if (options.sellingPlanId) {
      return options.sellingPlanId.toString();
    }

    return sellingPlanIdForVariant(variantId);
  }

  function cartErrorMessage(error) {
    if (!error) return 'Unable to add this item to your box. Please try again.';

    if (typeof error === 'string') return error;
    if (error.description && error.description.indexOf('Cannot apply selling plan') !== -1) {
      return 'This product is not available for the selected delivery frequency. In Shopify/Appstle, attach the matching selling plan to this product, or choose another item.';
    }
    if (error.message && error.description) return error.description;
    if (error.message) return error.message;
    if (error.description) return error.description;

    return 'Unable to add this item to your box. Please try again.';
  }

  function lineSellingPlanId(line) {
    if (!line) return '';
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id) {
      return line.selling_plan_allocation.selling_plan.id.toString();
    }
    if (line.selling_plan) return line.selling_plan.toString();
    return '';
  }

  function addedLineFromResponse(data) {
    if (!data) return null;
    if (data.key) return data;
    if (Array.isArray(data.items) && data.items.length) return data.items[0];
    return null;
  }

  function cartJsonHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  function changeLineSellingPlan(lineKey, quantity, sellingPlanId) {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var payload = {
      id: lineKey,
      quantity: quantity
    };

    if (sellingPlanId) {
      payload.selling_plan = parseInt(sellingPlanId, 10) || sellingPlanId;
    }

    return fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: cartJsonHeaders(),
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function addToBox(variantId, quantity, options) {
    options = options || {};
    var state = readState();
    var config = readConfig();
    var sellingPlanId = resolveSellingPlanForVariant(variantId, state, config, options);
    var oneTime = isOneTimeFrequency(state.delivery_frequency);

    if (!variantId) {
      return Promise.reject(new Error('Missing variant ID'));
    }

    if (!sellingPlanId && !oneTime) {
      return Promise.reject(new Error('No subscription plan is configured for the selected delivery frequency. Attach the matching Appstle selling plan to this product in Shopify admin.'));
    }

    var payload = {
      id: parseInt(variantId, 10) || variantId,
      quantity: quantity || 1,
      properties: buildLineItemProperties(options.properties)
    };

    if (sellingPlanId && !oneTime) {
      payload.selling_plan = parseInt(sellingPlanId, 10) || sellingPlanId;
      payload.properties._byob_selling_plan_id = sellingPlanId.toString();
    }

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: cartJsonHeaders(),
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        var line = addedLineFromResponse(data);
        var expectedId = sellingPlanId && !oneTime ? sellingPlanId.toString() : '';
        if (line && line.key && expectedId && lineSellingPlanId(line) !== expectedId) {
          return changeLineSellingPlan(line.key, line.quantity || quantity || 1, expectedId).then(function () {
            return data;
          }).catch(function () {
            return data;
          });
        }
        return data;
      })
      .then(function (data) {
        requestVolumeDiscount();
        document.dispatchEvent(new CustomEvent('cart:build'));
        return data;
      });
  }

  function changeBoxQuantity(lineKey, quantity) {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        requestVolumeDiscount();
        document.dispatchEvent(new CustomEvent('cart:build'));
        return data;
      });
    });
  }

  function getValidationRules() {
    var config = readConfig();
    return (config && config.babValidation) || {};
  }

  window.CongerAppstleByob = {
    STORAGE_KEY: STORAGE_KEY,
    readConfig: readConfig,
    readState: readState,
    writeState: writeState,
    ensureBundleUid: ensureBundleUid,
    resolveSellingPlanId: resolveSellingPlanId,
    ensureSellingPlanId: function () {
      return ensureSellingPlanId(readState(), readConfig());
    },
    syncSellingPlanFromFrequency: syncSellingPlanFromFrequency,
    cartErrorMessage: cartErrorMessage,
    buildLineItemProperties: buildLineItemProperties,
    addToBox: addToBox,
    changeBoxQuantity: changeBoxQuantity,
    getValidationRules: getValidationRules,
    bundleHandle: function () {
      return bundleHandle(readConfig());
    }
  };
})();
